import { VStack, Text, Button } from '@chakra-ui/react';
import BaseDialog from '../../../Dialogs/BaseDialog';
import Perdidex from '../../../../assets/images/perdidex.svg';

interface BrowserIncompatibilityModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function BrowserIncompatibilityModal({ isOpen, onClose }: BrowserIncompatibilityModalProps) {
  return (
    <BaseDialog isOpen={isOpen} onClose={onClose} width="400px" persist={false}>
      <VStack spacing="24px" align="center" textAlign="center" py="20px">
        <img src={Perdidex} alt="Ícone de aviso" />

        <Text fontSize="24px" fontWeight="700" color="#3D0E6B" lineHeight="28px">
          Seu navegador não é compatível
        </Text>

        <Text fontSize="16px" fontWeight="400" color="#6B7280" lineHeight="20px" maxW="320px">
          Para utilizar essa funcionalidade, tente outro navegador ou atualize o navegador atual
        </Text>

        <Button
          width="100%"
          height="48px"
          bg="#6B46C1"
          color="white"
          borderRadius="24px"
          fontWeight="600"
          fontSize="16px"
          onClick={onClose}
          _hover={{
            bg: '#5B3A9B',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(107, 70, 193, 0.3)',
          }}
          _active={{
            transform: 'translateY(0px)',
            bg: '#4A2F7A',
          }}
          transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
        >
          Entendi
        </Button>
      </VStack>
    </BaseDialog>
  );
}

export { BrowserIncompatibilityModal };
